import React from 'react';
import useStyles from '../../theme/useStyles';

// Pairs with useDateRangeFilter().
export interface DateRangeFilterProps {
  startDate: string;
  setStartDate: (v: string) => void;
  endDate: string;
  setEndDate: (v: string) => void;
  clear: () => void;
  isActive: boolean;
  /** Called after any change — typically to reset pagination. */
  onChange?: () => void;
  isDarkMode?: boolean;
}

const DateRangeFilter = ({
  startDate, setStartDate,
  endDate, setEndDate,
  clear, isActive,
  onChange,          // called after any change, e.g. to reset pagination
  isDarkMode
}: DateRangeFilterProps) => {
  const s = useStyles(isDarkMode);

  const label = { fontSize: s.t.fontSize.base, color: s.t.textMuted, fontWeight: 'bold' };
  const field = { ...s.input, width: 'auto', margin: 0 };

  const update = (setter) => (e) => { setter(e.target.value); onChange?.(); };

  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={label}>From:</span>
      <input type="date" value={startDate} onChange={update(setStartDate)} style={field} />
      <span style={label}>To:</span>
      <input type="date" value={endDate} onChange={update(setEndDate)} style={field} />
      {isActive && (
        <button
          type="button"
          onClick={() => { clear(); onChange?.(); }}
          style={{ background: 'transparent', border: 'none', color: s.t.danger, cursor: 'pointer', fontWeight: 'bold', fontSize: s.t.fontSize.sm }}
        >
          ✕ Clear
        </button>
      )}
    </div>
  );
};

export default DateRangeFilter;
